<template>
  <div :class="type">
    <el-empty :image-size="86.5" v-if="type === 'empty'" v-bind="$props" :description="description">
      <img slot="image" src="@/static/image/home/empty.webp" alt="" srcset="" />
    </el-empty>
     <el-empty :image-size="126" v-if="type === 'inspect'" >
      <img slot="image" src="@/static/image/home/empty2.webp"  alt="" srcset="" />
      <div slot="description"></div>
    </el-empty>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "empty",
    },
    description:{
      type: String,
      default: "暂无数据"
    }
  },
};
</script>

<style lang="scss" scoped>
.inspect{
    background-image: url(~@/static/image/home/empty_bg.webp);background-size: auto 100%;
}
</style>
